import { UpdateCurrentFlowRequestInterface } from 'src/interfaces/user.d'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { get } from 'lodash'

import { UserRequestInterface } from 'src/interfaces/user'
import { UseFormReturn } from 'react-hook-form/dist/types/form'
import { HTTP_CODE } from 'src/constants/app'
import LocalStorage from 'src/utils/LocalStorage'
import userRequest from 'src/api/requests/user'
import history from 'src/libs/history'
import appActions from 'src/store/ui/app'
import notificationAction from 'src/store/domain/notification/countUnreadNotification'
import setNotificationActions from 'src/store/ui/notification'
// import userDetail from 'src/store/domain/user/detail'
import { PATH as ERROR_PATH } from 'src/pages/error'
export interface PostRegister {
  credentials: UserRequestInterface
  meta: UseFormReturn<UserRequestInterface, any>
  redirectPath: string
}

export interface GetUserInfo {
  with?: string
}

export const register = createAsyncThunk<any, PostRegister>(
  'register',
  async (
    { credentials, meta, redirectPath },
    { dispatch, rejectWithValue },
  ) => {
    try {
      const res = await userRequest.register({
        ...credentials,
        ...{ clinic_uuid: LocalStorage.getClinicUuid() },
      })
      const token = get(res, 'data.access_token')

      LocalStorage.setToken(token)
      // [SCOPE] Navigate BEFORE getInfo so RestrictLayout's
      // (accessToken && isRegisterRoute) guard sees the new route before
      // authInfo lands in Redux — preventing a redirect to /other-menu
      // that would override the intended post-registration destination.
      redirectPath && history.push(redirectPath)
      await dispatch(
        getInfo({
          with: 'reservations,card,stateTransitions,cycleOrderPaid,latestOrderCanPay,userTreatments.reservations',
        }),
      )
    } catch (err: any) {
      const { status, data } = err.response
      const errors = data?.errors

      if (status === HTTP_CODE.BAD_REQUEST) {
        dispatch(
          setNotificationActions.onNotification({
            type: 'error',
            message: data?.message || '登録に失敗しました。',
          }),
        )
      }

      if (status === HTTP_CODE.UNPROCESSABLE_ENTITY) {
        if (errors?.clinic_uuid?.[0]) {
          history.push(ERROR_PATH.STATUS_ERROR)
        }

        Object.entries(errors || {}).forEach(([key, value]) => {
          if (Array.isArray(value) && value[0]) {
            meta.setError(key as any, { type: 'api', message: value[0] })
          }
        })
      }
      return rejectWithValue('register_failed')
    }
  },
)

export const getInfo = createAsyncThunk<any, GetUserInfo>(
  'user_info',
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const res = await userRequest.userInfo(params)

      dispatch(appActions.updateAuthInfo(res.data))
      dispatch(notificationAction.updateEntity(res.data?.notice_unread_count))

      return res.data
    } catch (err: any) {
      const status = err.response.status

      if (status === HTTP_CODE.UNAUTHORIZED) {
        history.push('login')
      }

      return rejectWithValue('user_info_failed')
    }
  },
)

export const updateCurrentFlow = createAsyncThunk<
  any,
  UpdateCurrentFlowRequestInterface
>('update_current_flow', async (params, { dispatch, rejectWithValue }) => {
  await userRequest.updateCurrentFlow(params)
})

export const updateUserInfo = createAsyncThunk<any, any>(
  'update_user_info',
  async (params, { dispatch, getState, rejectWithValue }) => {
    try {
      const res = await userRequest.updateUserInfo(params)
      const state = getState() as any
      const authInfo = state.ui.app.authInfo
      if (authInfo) {
        dispatch(appActions.updateAuthInfo({ ...authInfo, ...res.data }))
      } else {
        dispatch(appActions.updateAuthInfo(res.data))
      }
      return res.data
    } catch (err: any) {
      return rejectWithValue(err.response?.data || err.message)
    }
  },
)

// export const getDetailInfo = createAsyncThunk<any, GetUserInfo>(
//   'user_detail_info',
//   async (params, { dispatch }) => {
//     try {
//       dispatch(userDetail.updateLoading(true))
//       const res = await userRequest.userInfo(params)

//       dispatch(userDetail.updateEntity(res.data))
//       dispatch(userDetail.updateLoading(false))
//     } catch (err: any) {
//       dispatch(userDetail.updateLoading(false))
//     }
//   },
// )
